export default "__VITE_ASSET__6zQ2$nxu__"